import { render, staticRenderFns } from "./PowerDetail.vue?vue&type=template&id=c1f0a1c2&scoped=true&"
import script from "./PowerDetail.vue?vue&type=script&lang=js&"
export * from "./PowerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PowerDetail.vue?vue&type=style&index=0&id=c1f0a1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0a1c2",
  null
  
)

export default component.exports